import axios from 'axios'
import { stringify } from 'qs'
import dd from '@/utils/dd.config'
import doLogin from '@/utils/login'

const loginApi = '/user/login'

// 默认请求格式
const DefaultContentType = 'application/json'
const baseURL = '/work'

const instance = axios.create({
  baseURL,
  timeout: 20000, // 默认20s，对特定需要配置的接口只需要配置自定义字段
  withCredentials: false,
  responseType: 'json',
  headers: { 'Content-Type': DefaultContentType },
  // 定义可获得的http响应状态码
  // return true、设置为null或者undefined，promise将resolved,否则将rejected
  validateStatus(status) {
    return status >= 200 && status < 300 // default
  }
})


// 添加一个请求拦截器
instance.interceptors.request.use(
  config => {
    // 配置 rap2 模拟数据, 配置请求参数
    if (config.method === 'post') {
      if (config.data) {
        if (config.data._baseUrl) {
          config.baseURL = config.data._baseUrl
          delete config.data._baseUrl
        }
      } else {
        const _data = {}
        config.data = _data
      }
    } else if (config.params) {
      if (config.params._baseUrl || config.params._baseUrl !== undefined) {
        config.baseURL = config.params._baseUrl
        delete config.params._baseUrl
      }
    } else {
      const _data = {}
      config.params = _data
    }

    if (!config.headers.token && config.url !== `${baseURL}${loginApi}`) {
      config.headers.token = localStorage.getItem('TOKEN')
    }
    if (config.onLoad) {
      config.timeout = 100000
      delete config.onLoad
    }
    return config
  },
  error => Promise.reject(error)
)

// 添加一个响应拦截器
instance.interceptors.response.use(response => {
  const disposition = response.headers['content-disposition']
  if (disposition) {
    const fileBlob = new Blob([response.data])
    const fileName = decodeURIComponent(
      disposition.split(';')[1].split('filename=')[1]
    )
    const link = document.createElement('a')
    link.href = URL.createObjectURL(fileBlob)
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href)
    document.body.removeChild(link)
    return fileBlob
  }
  // if (response.headers.token) {
  //   const token = response.headers.token
  //   localStorage.setItem('TOKEN', token)
  // }
  // 登录过期
  if (response.data && response.data.errorCode === '1002') {
    doLogin().then(() => window.location.reload())
    // dd.toast('error', '获取数据失败，请重新登陆!')
  }
  return response
}, error => Promise.reject(error))

// 将请求数据的方式包装成一个对象
const api = {}
const likeGet = ['delete', 'get', 'head', 'options']
const likePost = ['post', 'put', 'patch']

api.request = function (...argus) {
  const _arguments = Array.prototype.slice.call(argus)
  const isPost = _arguments[0]
  const method = _arguments[1]
  const url = _arguments[2]
  const data = _arguments[3] || {}
  const other = _arguments[4] || {}
  const config = { method, url }
  // if (typeof other === 'string') {
  //   const sign = encipher(data, other)
  //   config.headers = { ...(config.headers || {}), sign }
  // } else {
  //   if (other.sign) {
  //     const sign = encipher(data, other.sign)
  //     delete other.sign
  //     other.headers = { ...(other.headers || {}), sign }
  //   }
  //   Object.assign(config, other)
  // }

  config[isPost ? 'data' : 'params'] = data
  return new Promise((resolve, reject) => {
    instance
      .request(config)
      .then(res => {
        if (res.data) {
          res.data.success ? resolve(res.data) : reject(res.data)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

likeGet.forEach(method => {
  api[method] = function (...argus) {
    return api.request(false, method, ...argus)
  }
})

likePost.forEach(method => {
  api[method] = function (...argus) {
    return api.request(true, method, ...argus)
  }
})

export default api
